import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex-1 overflow-y-auto mt-3 mb-3" }
const _hoisted_2 = { class: "flex flex-col gap-3" }
const _hoisted_3 = ["onClick"]

import { useBlogTagsStore } from "@/stores/blogTagsStore";
import { useLangStore } from "@/stores/langStore";
import { onMounted } from "vue";
import { useBlogsStore } from "@/stores/blogsStore";
import { useSelectBlogTag } from "@/utils/useSelectBlogTag";


export default /*@__PURE__*/_defineComponent({
  __name: 'TagSidebarItems',
  emits: ["closeMenu"],
  setup(__props, { emit: __emit }) {

const tagsStore = useBlogTagsStore();
const blogStore = useBlogsStore();
const langStore = useLangStore();
const { selectTag } = useSelectBlogTag();

const emits = __emit;

onMounted(() => {
  tagsStore.loadBlogTags();
});

function handleSelectTag(tagId: number) {
  selectTag(tagId);
  emits("closeMenu");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tagsStore).blogTags, (tag) => {
        return (_openBlock(), _createElementBlock("div", {
          key: tag.id,
          class: _normalizeClass(["group flex justify-between items-center px-4 py-2 border rounded-lg text-left", [
          _unref(tagsStore).selectedBlogTagId === tag.id
            ? 'bg-brown text-white pointer-events-none'
            : 'text-brown bg-white hover:bg-hover hover:cursor-pointer',
          _unref(blogStore).isListLoading ? 'pointer-events-none opacity-50' : '',
        ]]),
          onClick: ($event: any) => (handleSelectTag(tag.id))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["sf-pro-sm", 
            _unref(tagsStore).selectedBlogTagId === tag.id
              ? 'text-white'
              : 'group-hover:text-active'
          ])
          }, _toDisplayString(tag.translations[_unref(langStore).current] ||
            tag.translations[_unref(langStore).fallbackLang]), 3),
          _createElementVNode("span", {
            class: _normalizeClass(["tag-counter", 
            _unref(tagsStore).selectedBlogTagId === tag.id
              ? 'bg-white text-black'
              : 'bg-muted group-hover:bg-active text-white'
          ])
          }, _toDisplayString(tag.blogsCount), 3)
        ], 10, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})